export default __webpack_public_path__ + "images/c6c518a312eadc453fc11d83877fc9ae-iconos_facebook.svg";